import React from 'react';
import Icon from '../../../components/AppIcon';
import Select from '../../../components/ui/Select';

const FilterBar = ({ filters, onFilterChange }) => {
  const statusOptions = [
    { value: 'all', label: 'All Encounters' },
    { value: 'upcoming', label: 'Upcoming' },
    { value: 'pending-feedback', label: 'Pending Feedback' },
    { value: 'completed', label: 'Completed' }
  ];

  const sortOptions = [
    { value: 'date-desc', label: 'Newest First' },
    { value: 'date-asc', label: 'Oldest First' },
    { value: 'satisfaction-desc', label: 'Highest Rated' },
    { value: 'satisfaction-asc', label: 'Lowest Rated' }
  ];

  return (
    <div className="bg-card border border-border rounded-md p-4">
      <div className="flex flex-col md:flex-row gap-4">
        <div className="flex-1">
          <Select
            label="Status"
            options={statusOptions}
            value={filters?.status}
            onChange={(value) => onFilterChange('status', value)}
          />
        </div>
        <div className="flex-1">
          <Select
            label="Sort By"
            options={sortOptions}
            value={filters?.sortBy}
            onChange={(value) => onFilterChange('sortBy', value)}
          />
        </div>
        <div className="flex items-end">
          <button
            onClick={() => onFilterChange('reset')}
            className="flex items-center space-x-2 px-4 py-2 h-10 bg-muted text-foreground rounded-md hover:bg-muted/80 transition-therapeutic text-sm font-medium"
          >
            <Icon name="RotateCcw" size={16} color="currentColor" />
            <span>Reset</span>
          </button>
        </div>
      </div>
    </div>
  );
};

export default FilterBar;